export default "__VITE_ASSET__BDTF_CAh__"